<template>
  <div class="chart-box">
    <div class="chart-box-item-box">
      <div v-for="(item, index) in list" :key="index" class="chart-box-item">
        <div class="chart-text-box">
          <img class="chart-box-img" :src="bedImg[item.bedStatus]" alt="" />
          <div class="chart-box-text">
            {{ item.name }}-{{ bedStatusMap.get(item.bedStatus) }}
          </div>
        </div>
        <div
          v-if="popupType(item.popupInfo.alarmType) == 1"
          class="chart-box-item-popup"
        >
          <img
            class="chart-box-item-popup-img"
            src="../../../assets/dialogBlue.png"
            alt=""
          />
          <div class="chart-box-item-popup-info">
            <div class="info-title">床位信息</div>
            <div class="info-body">
              <div>病床号：{{ item.name || "-" }}</div>
              <!-- <div>状态：{{ bedStatusMap.get(item.bedStatus) }}</div> -->
              <div>病人：{{ item.iotUser ? item.iotUser.name : "-" }}</div>
              <div>告警内容：{{ item.popupInfo.content }}</div>
              <!-- <div>设备号：{{ item.devicesVo ? item.devicesVo.id : "-" }}</div> -->
            </div>
          </div>
        </div>
        <div
          v-if="popupType(item.popupInfo.alarmType) == 2"
          class="chart-box-item-popup"
        >
          <img
            class="chart-box-item-popup-img"
            src="../../../assets/dialogGreen.png"
            alt=""
          />
          <div class="chart-box-item-popup-info">
            <div class="info-title">床位信息</div>
            <div class="info-body">
              <div>病床号：{{ item.name }}</div>
              <!-- <div>状态：{{ bedStatusMap.get(item.bedStatus) }}</div> -->
            </div>
          </div>
        </div>
        <div
          v-if="popupType(item.popupInfo.alarmType) == 3"
          class="chart-box-item-popup"
        >
          <img
            class="chart-box-item-popup-img"
            src="../../../assets/dialogRed.png"
            alt=""
          />
          <div class="chart-box-item-popup-info">
            <div class="info-title">告警信息</div>
            <div class="info-body">
              <div>病床号：{{ item.name }}</div>
              <!-- <div>状态：{{ bedStatusMap.get(item.bedStatus) }}</div> -->
              <div>病人：{{ item.iotUser ? item.iotUser.name : "-" }}</div>
              <div>告警内容：{{ item.popupInfo.content }}</div>
              <!-- <div>设备号：{{ item.devicesVo ? item.devicesVo.id : "-" }}</div> -->
            </div>
          </div>
        </div>

        <!-- <div class="chart-box-item-popup">
          <img
            class="chart-box-item-popup-img"
            src="../../../assets/dialogRed.png"
            alt=""
          />
          <div class="chart-box-item-popup-info">
            <div class="info-title">告警信息</div>
            <div class="info-body">
              <div>病床号：111</div>
              <div>病人：111</div>
              <div>告警内容：测试心率高于180，请注意不要剧烈运动</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      config: {},
      bedImg: [
        // require("../../../assets/bedGreen.png"),
        // require("../../../assets/bedBlue.png"),
        // require("../../../assets/bedOrange.png"),
        require("../../../assets/bedOrange.png"),
        require("../../../assets/bedBlue.png"),
        require("../../../assets/bedGreen1.png"),
        require("../../../assets/bedGreen1.png"),
      ],
      bedStatusList: ["空床", "在床", "离床"],
      // 0离床（橙色），1在床（蓝色），2空床（绿色），3初始化（绿色）
      bedStatusMap: new Map([
        [0, "离床"],
        [1, "在床"],
        [2, "空床"],
        [3, "空床"],
      ]),
    };
  },
  computed: {
    popupType() {
      return (type) => {
        if (type) {
          // const array1 = [1, 2, 3, 4];
          // const array2 = [5, 6, 7, 8];
          // const array3 = [111, 10, 11, 12];
          // if (array1.includes(type)) {
          //   return 1;
          // } else if (array2.includes(type)) {
          //   return 2;
          // } else if (array3.includes(type)) {
          //   return 3;
          // }
          return 3;
        } else {
          return "";
        }
      };
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.chart-box {
  margin-top: 20px;
  width: 100%;
  height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  .chart-box-item-box {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-row-gap: 10px;
    // grid-template-rows: repeat(10, 1fr);
  }
  .chart-box-item {
    // position: relative;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    // overflow: hidden; //超出的文本隐藏
    // text-overflow: ellipsis; //溢出用省略号显示
    // white-space: nowrap; //溢出不换行
    min-width: 0;
    .chart-text-box {
      text-align: center;
      width: 100%;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .chart-box-img {
      width: 90px;
      height: 40px;
    }
    .chart-box-text {
      text-align: center;
      width: 100%;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .chart-box-item-popup {
      position: absolute;
      width: 220px;
      // width: 230px;
      left: -35px;
      // left: -40px;
      bottom: 35px;
      .chart-box-item-popup-img {
        width: 100%;
      }
      .chart-box-item-popup-info {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        padding-top: 5px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Semibold;
        text-align: left;
        color: #ffffff;
        .info-title {
          padding-left: 30px;
          padding-top: 5px;
        }
        .info-body {
          margin-top: 10px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
